const data = {
  primaryColor: "#1976D2",
  lightColor: true,
  title: "davidsimak.dev",
  category: "Personal/portfolio website",
  icon: "/images/app-icons/davidsimak-dev.png",
  fullDescription:
    "Simple ReactJS website about me, my experience and my projects",
  shortDescription: "Simple ReactJS website about me, my experience and my projects",
  slogan: "A self-taught Java/Kotlin developer",
  usesCases: [
    "Get information about me",
    "Useful for recruiters",
    "Self promoting of me and my project",
    "To get information about my projects",
  ],
  properties: [
    "Information about me",
    "Detailed description about my projects and technologies that are used in them",
    "My experience, skills and companies where I worked",
    "My current job title and company where I worked",
    "What I am doing",
    "Contact about me",
    "Personal information about me, what I likes and direction where I am headed",
    "Terms of Services and Privacy policy for my products",
  ],
  services: [],
  android: null,
  frontend: {
    url: "https://www.davidsimak.dev",
    versioning: {
      releasedOn: new Date(2018, 7, 1),
      currentVersion: "2.0",
      updatedOn: new Date(2023, 1, 27),
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    responsivenessCompatibility: {
      phone: true,
      tablet: true,
      desktop: true,
    },
    techInformation: {
      language: "JavaScript",
      framework: "ReactJS",
      integrations: [],
      packageManager: "npm",
      webServer: "Nginx",
      virtualization: "Docker container",
      containerOS: "Alpine Linux",
      deployed: "k3s cluster",
    },
    images: [
      {
        title: "Front page",
        url: "../../images/project-screenshots/davidsimak-dev/david-simak-dev-web-1.png",
        description: "Front page of web",
      },
      {
        title: "About me  ",
        url: "../../images/project-screenshots/davidsimak-dev/david-simak-dev-web-2.png",
        description: "Page with information about me",
      },
      {
        title: "My experience",
        url: "../../images/project-screenshots/davidsimak-dev/david-simak-dev-web-3.png",
        description: "Page with information about my experience",
      },
      {
        title: "Contact me",
        url: "../../images/project-screenshots/davidsimak-dev/david-simak-dev-web-4.png",
        description: "Page with contact information",
      },
    ],
  },
  backend: null,
};

class DavidSimakDevProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "davidsimak-dev",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new DavidSimakDevProjectData();
